import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';

/**
 * A short hint that appears on hover or keyboard focus. Wrap one focusable element.
 * Tooltips only add context; never put the only copy of an instruction in one.
 */
const Tooltip = ({ content, side = 'top', children }) => {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} sideOffset={6} className="comp-tooltip__positioner">
          <BaseTooltip.Popup className="comp-tooltip">{content}</BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
};

export default Tooltip;
